import React, { useState, useEffect, useRef, forwardRef } from 'react';
import { Tab } from './Tab'
import { useQueryParams } from '../hooks';
import { keyCode } from '../helpers';

// emptyText / resultNoun default to Swedish — see the note in DataTable.js.
export const _Tabs = ({onTabChange, showResultCount, showNoResultsMessage=true, disableTabsWithoutResults, defaultSelectedTab, className, loading, emptyText="Inget att visa", resultNoun="träffar", children}, ref) => {

  const { setHistory } = useQueryParams()

  const [activeTab, setActiveTab] = useState(defaultSelectedTab?.tab)

  const refTabs = useRef([]);
  
  children = (Array.isArray(children) ? children : [children]) // If only one child, children will not be an array

  useEffect( () => {

    refTabs.current = new Array(children.length)

  }, []);

  useEffect( () => {
   
    setActiveTab(defaultSelectedTab?.tab || children[0].props.tabid)

  }, [defaultSelectedTab]);

  const onClickTabItem = (tab) => {
    setActiveTab(tab)

    // Call external function if provided
    if (onTabChange) { 
      
      setHistory({filter:"", sort: undefined})
      onTabChange(tab) 
    } else {
      setHistory({tab: tab, filter:"", sort: undefined})
    }
    
  }
  
  const focusNextListItem = (direction) => {
    const activeElement = document.activeElement;

    const activeElementIndex = refTabs.current.findIndex(el => el === activeElement)
    const activeTabIndex = activeElementIndex < 0 ? children.findIndex(el => el.props.tabid === activeTab) : activeElementIndex
    
    if (activeTabIndex >= 0) {
      if (direction === keyCode.RIGHT_ARROW && activeTabIndex+1 < refTabs.current.length) {
        refTabs.current[activeTabIndex+1].focus()
      } else if (direction === keyCode.LEFT_ARROW && activeTabIndex > 0) {
        refTabs.current[activeTabIndex-1].focus()
      }
    } else {
      refTabs.current[0].focus()
    }
  }

  const handleKeyDown = (e, val) => {
    switch (e.keyCode) {
      case keyCode.LEFT_ARROW:
        focusNextListItem(keyCode.LEFT_ARROW);
        break;

      case keyCode.RIGHT_ARROW:
        focusNextListItem(keyCode.RIGHT_ARROW);
        break;

      default:
        break;
    }
  }
  
  return (
    <div className={"CustomTabs" + (className ? " " + className : "") + (showResultCount ? " show-result-count" : "")} name="Tabs">
      <div className="tab-header">

        <div 
          className="tab-list"
          role="tablist"
          onKeyDown={handleKeyDown}
        >
          {children.map( (child, i) => {

            if (child === undefined || child === null) return null

            const { label, tabid, resultCount, disabled } = child.props;

            //if (resultCount === 0 && tabid !== 'all') return null

            return (
              <Tab
                ref={el => refTabs.current[i] = el}
                activeTab={activeTab}
                key={i}
                label={label}
                tabid={tabid}
                resultCount={resultCount}
                onClick={onClickTabItem}
                disableTab={(disableTabsWithoutResults && resultCount===0) || disabled}

              />
            );
          })}
        </div>
      </div>

      <div className="tab-content-wrapper" ref={ref} role="tabpanel">
       {children.map((child, index) => {
        
          const { label, tabid, resultCount, disabled } = child.props;

          

          if (child === undefined || child === null || tabid !== activeTab) return undefined;
          
          if (!loading && (((disableTabsWithoutResults && resultCount===0) && showNoResultsMessage) || disabled)) {
            return (<div className="tab-content-empty-text" key={index}>{emptyText}</div>)
          }

          return (
            <div className="tab-content" key={index}>
              { showResultCount &&
              <div className="result-count">{resultCount > 0 && resultCount + " " + ((tabid !== 'all') ? label : resultNoun)}</div>
              }
              {child.props.children}
            </div>
            );

          })
        }
      </div>
      
    </div>
  );
};

export const Tabs = forwardRef(_Tabs);
